import { DropdownMenu, Input } from "react-vant";
import { prefix } from ".";
import { useSelector } from "react-redux";
import { IReducersState } from "@/reducers";
import { useEffect, useState } from "react";
import Config from "@/libs/config";
import { IAreaCodes } from "@/types/common-types";
import { findNode } from "@/utils";
import { useTranslation } from "react-i18next";

interface IPhoneNumberProps {
  value?: any;
  onChange?: (value: string) => void;
}

const PhoneNumber: React.FC<IPhoneNumberProps> = (props) => {
  const { value, onChange } = props;

  const { t } = useTranslation('common');
  const areaCodes = useSelector((state: IReducersState) => state.common.areaCodes);

  const defaultValue = {
    name: 'Hong Kong (China)',
  }

  const [showValue, setShowValue] = useState<Record<string, string | number>>();
  const [inputValue, setInputValue] = useState<string>('');

  useEffect(() => {
    let inputValue = '';
    let dialCode = '';
    let dialItem: IAreaCodes | undefined = undefined;
    if (value) {
      if (value.startsWith('+')) {
        inputValue = value.substring(value.indexOf(' ') + 1);
        dialCode = value.substring(0, value.indexOf(' ')).replace('+', '');
      } else {
        inputValue = value;
      }

      dialItem = findNode<IAreaCodes>(areaCodes, 'phoneCountryCode', dialCode);

      if (dialItem) {
        setShowValue({
          name: dialItem.name
        })
      }
    } else {
      setShowValue(defaultValue)
    };

    setInputValue(inputValue);
 // eslint-disable-next-line
  }, [value]);

  const options = areaCodes.map(item => {
    return {
      text: <div className={`${prefix}-item`} key={item.isoAlpha2Code}>
        <span className={`${prefix}-item-img`}>
          <img
            width="48px"
            height="48px"
            src={`${Config.staticPath}/images/country-flag/${item.isoAlpha2Code
              ? item.isoAlpha2Code.toLocaleLowerCase()
              : 'hk'
              }.svg`}
            alt=""
          />
        </span>
        <span className={`${prefix}-item-text`}>
          +{item.phoneCountryCode}
        </span>
      </div>,
      value: item.name,
    }
  });

  const handleValueChange = (value: any, type: 'select' | 'input') => {
    if (onChange) {
      let newValue = '';
      if (type === 'select') {
        let selectValue = showValue?.name;
        const name = value.name || '';
        let dialItem = findNode<IAreaCodes>(areaCodes, 'name', name);

        if (!dialItem) {
          dialItem = findNode<IAreaCodes>(areaCodes, 'name', selectValue);
        };

        if (dialItem) {
          newValue = `+${dialItem?.phoneCountryCode} ${inputValue}`;
        } else {
          newValue = `${inputValue}`;
        }
        
      } else {
        const name = showValue?.name;
        let dialCode = '';
        if (name) {
          const dialItem = findNode<IAreaCodes>(areaCodes, 'name', name);
          if (dialItem) {
            dialCode = `+${dialItem.phoneCountryCode}`;
          }
        };

        if (dialCode) {
          newValue = `${dialCode} ${value}`
        } else {
          newValue = `${value}`
        }
      }

      onChange(newValue)
    } else {
      if (type === 'select') {
        setShowValue(value);
      } else {
        setInputValue(value);
      }
    }
  }

  return (
    <div
      className={`${prefix}`}
    >
      <DropdownMenu
        direction='up'
        onChange={(data) => handleValueChange(data, 'select')}
        value={showValue}
        defaultValue={defaultValue}
      >
        <DropdownMenu.Item name="name" options={options} />
      </DropdownMenu>
      <Input onChange={(value) => handleValueChange(value, 'input')} value={inputValue} type="number" placeholder={t('phoneNumberPlaceholder')} />
    </div>
  )
};

export default PhoneNumber;